import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";


// videos

// Import profile header component
import CourseCard from "./CourseCard";
import { AllCoursesData } from "../../../../constant-data/online-training-data";

const ViewAllTraining = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState(JSON.parse(localStorage.getItem("users")));
    const [courses, setCourses] = useState([]);


    useEffect(() => { setCourses(AllCoursesData) }, [])

    // -------- Get all courses
    // const getEnrolledCourses = async () => {
    //     try {
    //         const response = await axios.post(webServiceUrl.allPrograms, {
    //             users,
    //         });
    //         // console.log(response);

    //         setCourses(response?.data?.allPrograms);
    //     } catch (error) {
    //         console.log(error, "ERROR coming From  getallPrograms ");
    //         setCourses([]);
    //     }
    // };
    // useEffect(() => {
    //     localStorage.removeItem("current-course");
    //     getEnrolledCourses();
    // }, []);

    useEffect(() => {
        const timer = setTimeout(() => setIsLoading(false), 400);
        setUsers(JSON.parse(localStorage.getItem("users")));
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* <ProfileHeader img={profilebg8} /> */}
            <div
                id="content-page"
                className="content-inner store-details upcoming-card pt-4 mt-0 border"
            >
                <Container>
                    <Row className="">
                        <div
                            className="header-title mb-4 pb-2"
                            style={{ textAlign: "left", width: "100%" }}
                        >
                            <h1
                                style={{
                                    textAlign: "center",
                                    width: "100%",
                                }}
                            >All Courses</h1>
                        </div>
                        {isLoading
                            ? Array.from({ length: 6 }).map((_, index) => (
                                <Col sm="6" md="6" lg="4" key={index}>
                                    <Skeleton height={250} className="rounded-3" />
                                    <Skeleton height={20} width="80%" className="mt-2" />
                                    <Skeleton height={15} width="90%" />
                                    <Skeleton height={15} width="70%" />
                                    <Skeleton height={15} width="50%" />
                                </Col>
                            ))
                            : courses?.map((item) => (
                                <Col sm="6" md="6" lg="4" key={item.id}>
                                    <div className="mx-3">
                                        <CourseCard course={item} />
                                    </div>
                                </Col>
                            ))}
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default ViewAllTraining;


//   const [courses, setCourses] = useState([
//         {
//             id: 1,
//             title: "Post Graduate Teacher",
//             logo_image: robotics,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/lesson-plan/PGT",
//             videos: [
//                 v1_1,
//                 Foodwaste_1,
//                 Foodwaste_2,
//                 v1_1,
//             ]
//         },
//         {
//             id: 2,
//             title: "Trained Graduate Teacher",
//             logo_image: arvr,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/lesson-plan/TGT",
//             videos: [
//                 "https://www.example.com/video1.mp4",
//                 "https://www.example.com/video2.mp4",
//                 "https://www.example.com/video3.mp4"
//             ]
//         },
//         {
//             id: 3,
//             title: "AI Program",
//             logo_image: ai,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/dashboards/store/product-detail",
//             videos: []
//         },
//         {
//             id: 4,
//             title: "MERN Stack Program",
//             logo_image: mern,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/dashboards/store/product-detail",
//             videos: []
//         },
//         {
//             id: 5,
//             title: "Java Development Program",
//             logo_image: java,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/dashboards/store/product-detail",
//             videos: []
//         },
//         {
//             id: 6,
//             title: "Machine Learning Program",
//             logo_image: machineLearning,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/dashboards/store/product-detail",
//             videos: []
//         },
//         {
//             id: 7,
//             title: "Python AI",
//             logo_image: python,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/dashboards/store/product-detail",
//             videos: []
//         },
//         {
//             id: 8,
//             title: "AI Program",
//             logo_image: ai,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/dashboards/store/product-detail",
//             videos: []
//         },
//         {
//             id: 9,
//             title: "MERN Stack Program",
//             logo_image: mern,
//             date: "10-Mar-2025 to 14-Mar-2025",
//             time: "9am to 2pm",
//             venue: "Tech Park, Sector 62, Noida.",
//             link: "/dashboards/store/product-detail",
//             videos: []
//         },
//     ]);